import React from "react";
import { Col, Row } from "react-bootstrap";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import i18n from "utils/I18n";
import { useTranslation } from "react-i18next";

import {
  ActivityLogIcon,
  MyProfileIcon,
  AboutIcon,
  LanguageIcon,
  RewardStatusIcon,
  TransactionHistoryIcon,
  RightArrow,
} from "component/base/SvgIcons";
import { MOBILE_PROFILE_PAGE_LAYOUT, NO_TRANSACTION_HISTORY } from "utils/Config";
import { inMiniProgram, navigateStack } from "utils/WeChatUtil";

import "./MobileViewProfileSubNavigator.scss"

const MobileViewProfileSubNavigator = ({
  isLogin
}) => {
  const history = useHistory();
  useTranslation();
  const isInMiniProgram = inMiniProgram()
  const loginProfileNavConfig = [
    {
      nameTranslationKey: "profile_activity_log",
      iconComponent: ActivityLogIcon,
      pathname: "/activity_log",
    },
    ...NO_TRANSACTION_HISTORY ? [] : [{
      nameTranslationKey: "profile_transaction",
      iconComponent: TransactionHistoryIcon,
      pathname: "/transaction_history",
    },],
    {
      nameTranslationKey: "profile_reward_status",
      iconComponent: RewardStatusIcon,
      pathname: "/reward_status",
    },
    {
      nameTranslationKey: "profile_account",
      iconComponent: MyProfileIcon,
      pathname: "/user/myAccount",
    },
    // ...isInMiniProgram ? [] : [
    //   {
    //     nameTranslationKey: "languages",
    //     iconComponent: LanguageIcon,
    //     pathname: "/language",
    //   },
    // ],
    {
      nameTranslationKey: "about",
      iconComponent: AboutIcon,
      pathname: "/mobile-about",
    },
  ]
  const unloginProfileNavConfig = [
    // ...isInMiniProgram ? [] : [
    //   {
    //     nameTranslationKey: "languages",
    //     iconComponent: LanguageIcon,
    //     pathname: "/language",
    //   },
    // ],
    {
      nameTranslationKey: "about",
      iconComponent: AboutIcon,
      pathname: "/mobile-about",
    },
  ]
  const profileNavConfig = isLogin ? loginProfileNavConfig : unloginProfileNavConfig

  return (
    <>
      {MOBILE_PROFILE_PAGE_LAYOUT === "VERTICAL" ?
        <div className="field-text profile-vertiacl-layout">
          {profileNavConfig?.map(item =>
            <div
              className="vertiacl-item"
              onClick={() => {
                (item?.pathname || item?.fullLink) && navigateStack({
                  pathname: item?.pathname,
                  fullLink: item?.fullLink,
                  history: history,
                })
              }}
            >
              <div>
                {item?.iconComponent && <item.iconComponent className="svg-color-p2 common-icon-size" />}
                <div>{i18n.t(item?.nameTranslationKey)}</div>
              </div>
              <RightArrow className={"svg-color-p2"}/>
            </div>
          )}
        </div> :
        <div className="body-1">
          <Row xs={4} md={6}>
            {profileNavConfig?.map(item =>
              <Col className="profile-sub-nav-item" onClick={() => {
                (item?.pathname || item?.fullLink) && navigateStack({
                  pathname: item?.pathname,
                  fullLink: item?.fullLink,
                  history: history,
                })
              }}>
                {item?.iconComponent && <item.iconComponent className={"svg-color-p2"} />}
                <div>{i18n.t(item?.nameTranslationKey)}</div>
              </Col>
            )}
          </Row>
        </div>
      }
    </>
  )
}


const mapStateToProps = (state) => ({
  isLogin: state.users.isLogin,
  language: state.users.language,
});

export default connect(mapStateToProps)(MobileViewProfileSubNavigator);

